import { take, fork } from 'redux-saga/effects';

function* takeOnlyFirst(patternOrChannel, saga, ...args) {
    while (true) { // eslint-disable-line
        const action = yield take(patternOrChannel);
        yield fork(saga, ...args.concat(action));
        break;
    }
}

module.exports = takeOnlyFirst;



// WEBPACK FOOTER //
// ./src/client/utils/take-only-first.js